<template>
	<CommissionsTableReact :commissions="commissions" />
</template>

<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { CommissionsTable } from "@/components/commissions/CommissionsTable";

const CommissionsTableReact = ReactInVue(CommissionsTable);

export default {
	name: "CommissionsTable",
	components: {
		CommissionsTableReact,
	},

	props: {
		commissions: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss">
.tp-commissionsTable {
	margin-bottom: 10px;
}
</style>
